import { Badge } from '@mantine/core';

/**
 * MED-1360: the status pill for a past session that the coach has not marked
 * yet. A participant does not mark attendance, so the pill is neutral. It
 * replaces "Scheduled", which is wrong once the time has passed.
 */
export function AttendancePendingBadge() {
  return (
    <Badge size="xs" color="gray" variant="light" style={{ textTransform: 'uppercase', letterSpacing: 0.3 }}>
      Attendance pending
    </Badge>
  );
}
